// extracted by mini-css-extract-plugin
export var priceTile = "styles-module--priceTile--s+6eL";
export var priceTileDescription = "styles-module--priceTileDescription--JWG51";
export var priceTilePrice = "styles-module--priceTilePrice--yLbFC";